import { generateApiPath } from "@routes/generatePath.ts";
import type { IExtractApiParams } from "@routes/types";

const pathBase = `/medical-service-provider/appointments/attend/:appointmentId`;

export type IPathBaseParams = IExtractApiParams<typeof pathBase>;

export const attend = {
  put: (params: IPathBaseParams) => generateApiPath(pathBase, params),
};
